import * as apis from '../reducers/apis';
import * as charts from '../reducers/charts';
import * as chartsAdmin from '../reducers/chartsAdmin';
import * as confirmation from '../reducers/confirmation';
import * as currentUser from '../reducers/currentUser';
import * as enquiries from '../reducers/enquiries';
import * as favouriteNumbers from '../reducers/favouriteNumbers';
import * as hospital from '../reducers/hospital';
import * as hospitals from '../reducers/hospitals';
import * as inviteRequests from '../reducers/inviteRequests';
import * as invites from '../reducers/invites';
import * as number from '../reducers/number';
import * as numbers from '../reducers/numbers';
import * as numbersCopy from '../reducers/numbersCopy';
import * as exclusionNumber from '../reducers/exclusionNumber';
import * as exclusionList from '../reducers/exclusionList';
import * as passwordResets from '../reducers/passwordResets';
import * as user from '../reducers/user';
import * as users from '../reducers/users';
import * as whitelistedDomain from '../reducers/whitelistedDomain';
import * as whitelistedDomains from '../reducers/whitelistedDomains';
import * as whitelistedUsers from '../reducers/whitelistedUsers';
import * as email from '../reducers/email';
import * as emails from '../reducers/emails';
import * as adminOrganisations from '../reducers/organisation/admin/organisations';
import * as adminOrganisation from '../reducers/organisation/admin/organisation';
import * as organisation from '../reducers/organisation/organisation';
import * as userOrganisations from '../reducers/organisation/userOrganisations';
import * as numbersImport from '../reducers/numbersImport';

import i18next from 'i18next';

const flashMessages = {
  errors: {
    [apis.LOAD_APIS_FAILED]: 'Could not load available countries',
    [charts.LOAD_DEFAULT_STATS_FAILED]: 'Could not load default stats data',
    [charts.LOAD_DIRECTORY_VIEWS_FAILED]: 'Could not load directory views data',
    [charts.LOAD_ROLES_FAILED]: 'Could not load roles data',
    [charts.LOAD_USAGE_FAILED]: 'Could not load usage data',
    [chartsAdmin.LOAD_DEFAULT_STATS_FAILED]:
      'Could not load default stats data',
    [chartsAdmin.LOAD_DIRECTORY_VIEWS_FAILED]:
      'Could not load directory views data',
    [chartsAdmin.LOAD_ROLES_FAILED]: 'Could not load roles data',
    [chartsAdmin.LOAD_SIGNUPS_FAILED]: 'Could not load signup data',
    [chartsAdmin.LOAD_UNIQUE_DIRECTORY_VIEWS_FAILED]:
      'Could not load unique directory views data',
    [confirmation.CONFIRMATION_CODE_REQUEST_FAILED_ALREADY_CONFIRMED]:
      'This account is already confirmed',
    [confirmation.CONFIRMATION_CODE_REQUEST_FAILED_GENERIC]:
      'Could not request confirmation email',
    [confirmation.CONFIRMATION_CODE_REQUEST_FAILED_NOT_FOUND]:
      'Could not request confirmation email, email not found',
    [confirmation.CONFIRMATION_FAILED]:
      'We could not confirm your account with this confirmation code, please check it is correct and try again',
    [currentUser.DEFAULT_HOSPITAL_FAILED]: 'Could not set as default hospital',
    [currentUser.FORBIDDEN_REQUEST]: 'Access Denied',
    [currentUser.HARD_DELETE_FAILED]:
      'We could not schedule your account for deletion, please try again or contact us at support@accurx.com',
    [currentUser.INVALID_CURRENT_PASSWORD]: 'Current password incorrect',
    [currentUser.REFRESH_SESSION_TOKEN_FAILED]:
      'Login timed out, please log back in',
    [currentUser.RELOAD_FAILED]: 'Could not load logged in user',
    [currentUser.SIGNIN_FAILED]: 'Username/Password invalid',
    [currentUser.UNCONFIRMED_USER_SIGNIN]:
      'Please confirm your account before logging in',
    [currentUser.UNFAVOURITE_HOSPITAL_FAILED]: 'Could not unfavourite hospital',
    [currentUser.UPDATE_USER_FAILED]: 'Could not update account',
    [enquiries.CREATE_ENQUIRY_FAILED]:
      'We could not create your ticket, if this issue persists you can email us at support@accurx.com',
    [favouriteNumbers.FAVOURITES_LOAD_FAILED]: 'Could not load favourites',
    [favouriteNumbers.NUMBER_FAVOURITING_FAILED]: 'Could not favourite number',
    [favouriteNumbers.NUMBER_UNFAVOURITING_FAILED]:
      'Could not unfavourite number',
    [hospital.HOSPITAL_LOAD_FAILED]: 'Could not load hospital',
    [hospital.HOSPITAL_UPDATE_FAILED]: 'Could not update hospital',
    [hospitals.CREATE_HOSPITAL_FAILED]: 'Could not create hospital',
    [hospitals.HOSPITALS_LOAD_FAILED]: 'Could not load hospitals',
    [inviteRequests.INVITE_REQUESTS_LOAD_FAILED]:
      'Could not load invite requests',
    [inviteRequests.REQUEST_INVITE_FAILED]: 'Could not request invite',
    [inviteRequests.REJECT_INVITE_REQUEST_FAILED]:
      'Could not reject invite request',
    [invites.INVITE_CREATE_FAILED]: 'Could not create invite',
    [invites.INVITE_CREATE_FAILED_ALREADY_INVITED]:
      'This email address has already been invited',
    [invites.INVITE_DESTROY_FAILED]: 'Could not delete invite',
    [invites.INVITES_LOAD_FAILED]: 'Could not load invites',
    [number.NUMBER_LOAD_FAILED]: 'Could not load number',
    [number.UPDATE_NUMBER_FAILED]: 'Could not update number',
    [numbers.CREATE_NUMBER_FAILED_DELAYED]: 'Could not create number',
    [numbers.DELETE_NUMBER_FAILED]: 'Could not delete number',
    [numbersCopy.COPY_NUMBERS_FAILED]: 'Could not copy numbers',
    [numbers.NUMBERS_LOAD_FAILED]: 'Could not load numbers',
    [numbers.LOCKING_NUMBER_FAILED]: 'Could not lock number',
    [numbers.UNLOCKING_NUMBER_FAILED]: 'Could not unlock number',
    [numbersImport.NUMBERS_IMPORTING_FAILED]: 'Could not import directory',
    [exclusionNumber.UPDATE_EXCLUSION_NUMBER_FAILED]: 'Could not update number',
    [exclusionList.CREATE_NUMBER_EXCLUSION_LIST_FAILED]:
      'Could not create number',
    [exclusionList.DELETE_NUMBER_EXCLUSION_LIST_FAILED]:
      'Could not delete number',
    [passwordResets.PASSWORD_RESET_FAILED]: 'Could not reset password',
    [passwordResets.PASSWORD_RESET_REQUEST_FAILED]:
      'Could not request password reset',
    [user.ADD_ADMINED_HOSPITAL_FAILED]:
      'Could not make user admin for this hospital',
    [user.ADD_ADMINED_ORG_FAILED]: `Could not make user admin for this ${i18next.t(
      'organisation'
    )}`,
    [user.REMOVE_ADMINED_ORG_FAILED]: `Could not remove user as admin for this ${i18next.t(
      'organisation'
    )}`,
    [user.COULD_NOT_PROCESS_VERIFICATION]:
      'Could not verify Professional Body Registration Number, please try again in a few moments.',
    [user.HARD_DELETE_FAILED]: 'Could not schedule user for deletion',
    [user.NO_PBRN_VERIFICATION_FAILED]:
      'Could not verify Professional Body Registration Number, this user does not have a PBRN',
    [user.RECOVER_USER_FAILED]: 'Could not recover user',
    [user.REMOVE_ADMINED_HOSPITAL_FAILED]:
      'Could not remove user from list of hospital admins',
    [user.SOFT_DELETE_FAILED]: 'Could not soft delete user',
    [user.UPDATE_USER_FAILED]: 'Could not update user',
    [user.USER_CONFIRMATION_FAILED]: 'Could not confirm user',
    [user.USER_LOAD_FAILED]: 'Could not load user',
    [users.CREATE_USER_FAILED]: 'Could not create user',
    [users.REGISTRATION_FAILED]:
      'Failed to register, please check below and try again',
    [users.USERS_LOAD_FAILED]: 'Could not load users',
    [whitelistedDomain.LOAD_WHITELISTED_DOMAIN_FAILED]:
      'Could not load whitelisted domain',
    [whitelistedDomain.LOAD_WHITELISTED_DOMAIN_USERS_FAILED]:
      'Could not load users',
    [whitelistedDomains.CREATE_WHITELISTED_DOMAIN_FAILED]:
      'Could not create whitelisted domain',
    [whitelistedDomains.DESTROY_WHITELISTED_DOMAIN_FAILED]:
      'Could not delete whitelisted domain',
    [whitelistedDomains.LOAD_WHITELISTED_DOMAINS_FAILED]:
      'Could not load whitelisted domains',
    [whitelistedUsers.LOAD_WHITELISTED_USERS_FAILED]:
      'Could not load whitelisted users',
    [whitelistedUsers.PROMOTE_USER_TO_ADMIN_FAILED]:
      'Could not promote user to admin',
    [emails.EMAILS_LOAD_FAILED]: 'Could not load Email addresses',
    [emails.CREATE_EMAIL_FAILED]: 'Could not add Email address',
    [emails.DELETE_EMAIL_FAILED]: 'Could not mark Email address as incorrect',
    [email.EMAIL_LOAD_FAILED]: 'Could not load Email address',
    [email.UPDATE_EMAIL_FAILED]: 'Could not update Email address',
    [adminOrganisations.ORGANISATIONS_LOAD_FAILED]: `Could not load ${i18next.t(
      'organisations'
    )}`,
    [adminOrganisations.CREATE_ORGANISATION_FAILED]: `Could not add ${i18next.t(
      'organisation'
    )}`,
    [adminOrganisation.ORGANISATION_LOAD_FAILED]: `Could not load  ${i18next.t(
      'organisation'
    )}`,
    [adminOrganisation.UPDATE_ORGANISATION_FAILED]: `Could not update ${i18next.t(
      'organisation'
    )}`,
    [numbers.NUMBER_IS_LOCKED]: 'This number cannot be edited or deleted',
  },
  success: {
    [confirmation.CONFIRMATION_CODE_REQUEST_SUCCESS]:
      'Confirmation email sent, please check your inbox',
    [confirmation.CONFIRMATION_SUCCESS]: 'Your account has been confirmed',
    [currentUser.DEFAULT_HOSPITAL_SUCCESS]: 'Default hospital updated',
    [currentUser.FAVOURITE_HOSPITAL_SUCCESS]: 'Hospital favourited',
    [currentUser.HARD_DELETE_SUCCESS]:
      'Your account has been scheduled for deletion, login within 14 days to cancel this',
    [currentUser.SIGNIN_SUCCESS]: 'Welcome to Accurx Switch',
    [currentUser.SIGNOUT]: 'Logged out',
    [currentUser.UNFAVOURITE_HOSPITAL_SUCCESS]: 'Hospital unfavourited',
    [currentUser.UPDATE_USER_SUCCESS]: 'Your account has been updated',
    [currentUser.USER_EMAIL_CHANGE_REQUESTED]:
      'Email change requested, please check your inbox for a confirmation email',
    [enquiries.CREATE_ENQUIRY_SUCCESS]:
      'Your enquiry has been received, we will get back to you shortly',
    [favouriteNumbers.NUMBER_FAVOURITING_SUCCESS]: 'Number favourited',
    [favouriteNumbers.NUMBER_UNFAVOURITING_SUCCESS]: 'Number unfavourited',
    [hospital.HOSPITAL_UPDATE_SUCCESS]:
      'Hospital Updated. Please wait for a while as we update all related data',
    [hospitals.CREATE_HOSPITAL_SUCCESS]: 'Hospital created',
    [inviteRequests.REQUEST_INVITE_SUCCESS]: 'Access request sent',
    [inviteRequests.REJECT_INVITE_REQUEST_SUCCESS]:
      'The request has been rejected and the user has been notified',
    [invites.INVITE_CREATE_SUCCESS]:
      'Invite sent, user will receive an email shortly',
    [invites.INVITE_DESTROY_SUCCESS]: 'Access revoked',
    [number.UPDATE_NUMBER_SUCCESS]: 'Number updated',
    [numbers.CREATE_NUMBER_SUCCESS]: 'Number Created',
    [numbers.DELETE_NUMBER_SUCCESS]: 'Number deleted',
    [numbers.LOCKING_NUMBER_SUCCESS]: 'Number locked',
    [numbers.UNLOCKING_NUMBER_SUCCESS]: 'Number unlocked',
    [numbersCopy.COPY_NUMBERS_SUCCESS]:
      'Your numbers have been successfully copied',
    [numbersImport.NUMBERS_IMPORTING_SUCCESS]: 'Directory imported',
    [exclusionNumber.UPDATE_EXCLUSION_NUMBER_SUCCESS]: 'Number updated',
    [exclusionList.CREATE_NUMBER_EXCLUSION_LIST_SUCCESS]: 'Number Created',
    [exclusionList.DELETE_NUMBER_EXCLUSION_LIST_SUCCESS]: 'Number deleted',
    [passwordResets.PASSWORD_RESET_FOR_USER_SUCCESS]:
      'Password reset email sent to user',
    [passwordResets.PASSWORD_RESET_REQUEST_SUCCESS]:
      'Password reset email sent, please check your inbox',
    [passwordResets.PASSWORD_RESET_SUCCESS]: 'Password updated',
    [user.ADD_ADMINED_HOSPITAL_SUCCESS]:
      'Successfully made user an admin for this hospital',
    [user.ADD_ADMINED_ORG_SUCCESS]: `Successfully made user an admin for this ${i18next.t(
      'organisation'
    )}`,
    [user.REMOVE_ADMINED_ORG_SUCCESS]: `Successfully removed user as an admin for this ${i18next.t(
      'organisation'
    )}`,
    [user.HARD_DELETE_SUCCESS]: 'User scheduled for hard deletion',
    [user.RECOVER_USER_SUCCESS]: 'Soft deleted user recovered',
    [user.REMOVE_ADMINED_HOSPITAL_SUCCESS]:
      'Successfully removed user as admin for this hospital',
    [user.SOFT_DELETE_SUCCESS]: 'User soft deleted',
    [user.UPDATE_USER_SUCCESS]: 'User updated',
    [user.USER_CONFIRMATION_SUCCESS]: 'User confirmed',
    [user.USER_EMAIL_CHANGE_REQUESTED]:
      'Email change requested, please check your inbox for a confirmation email',
    [user.VERIFIED_USER_PBRN_SUCCESS]:
      'User Professional Body Registration Number Status Updated',
    [user.LOG_OUT_MOBILE_DEVICE_SUCCESS]: 'Logged out from everywhere',
    [users.CREATE_USER_SUCCESS]:
      'Account created, user will receive confirmation email shortly',
    [users.REGISTRATION_SUCCESS]:
      'Account created, please check your inbox to confirm your account',
    [whitelistedDomains.CREATE_WHITELISTED_DOMAIN_SUCCESS]:
      'Approved Domain Created',
    [whitelistedDomains.DESTROY_WHITELISTED_DOMAIN_SUCCESS]:
      'Approved Domain deleted',
    [whitelistedUsers.PROMOTE_USER_TO_ADMIN_SUCCESS]:
      'User has been promoted to admin',
    [emails.CREATE_EMAIL_SUCCESS]: 'Email address was successfully added',
    [emails.COPY_EMAIL_SUCCESS]: 'Email address was copied successfully',
    [emails.DELETE_EMAIL_SUCCESS]: 'Email address marked as incorrect',
    [email.UPDATE_EMAIL_SUCCESS]: 'Email was updated successfully',
    [adminOrganisations.CREATE_ORGANISATION_SUCCESS]: `${i18next.t(
      'organisation'
    )} added`,
    [adminOrganisation.UPDATE_ORGANISATION_SUCCESS]: `${i18next.t(
      'organisation'
    )} was updated successfully. Please wait for a while as we enable ${i18next.t(
      'organisation'
    )} Messaging functionality`,
    [organisation.ORGANISATION_LOAD_FAILED]: `Failed to get ${i18next.t(
      'organisation'
    )} details`,
    [userOrganisations.USER_ORGANISATIONS_LOAD_FAILED]: `Failed to get ${i18next.t(
      'organisations'
    )}`,
  },
};

export default flashMessages;
